import { util } from '../../util'

export const setUpdateNotificationPayload = (currNotif, currUser, data) => {
    delete currNotif.updated
    currNotif['updated_by'] = currUser
    const {
        status,
        state = [],
        region = [],
        is_national = false,
        send_to_nonspecified = 'N',
    } = currNotif
    if (status === 'Ready' && state.length === 0 && (!region || region.length === 0)) {
        const regions = util.parseNotificationRegions(
            region,
            state,
            status,
            is_national,
            send_to_nonspecified
        )
        currNotif['region'] = regions
    }
    return { notification: { ...currNotif, ...data } }
}
